import React, { useEffect, useState } from 'react'
import Container from '@mui/material/Container';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { createErrorEmail, saveHomeData, searchCities } from '../redux/reducer/stepReducer/thunks';
import { setAdditionalData, setAllSteps, setCodpmpol, setCurrentTab, setErrorEncrypt, setFirstFormCompleted, setFirstStep, setGlobalTab, setHomeData, setTitularData } from '../redux/reducer/stepReducer/stepReducer';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Fade, FormHelperText, Modal, Typography } from '@mui/material';
import { CODEMP_MUSIMUNDO, corregirCaracteresRotos, handleKeyDown, handleKeyDown2 } from '../utilities'
import CustomSelect from '../components/CustomSelect';
import Spinner from '../components/Spinner';
import Layout from '../components/Layout';

const customStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '287px',
    bgcolor: '#ECE6F0',
    borderRadius: '20px',
    p: '16px',
};

const HomeData = () => {
    const [listCities, setListCities] = useState([]);
    const [valueProvince, setValueProvince] = useState(null);
    const [valueCity, setValueCity] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [goToNextPage, setGoToNextPage] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const homeData = useSelector((state) => state.firstStep.homeData);
    const firstStep = useSelector((state) => state.firstStep.firstStep);
    const { codpmpol, statePlanDetail, titularData } = useSelector((state) => state.firstStep);
    const { provinces, cities, codemp } = useSelector(state => state.adminReducer.login);
    const [error, setError] = useState({
        address: false,
        homeType: false,
        province: false,
        city: false,
        squareMeters: false,
        registeredAddress: false,
    });
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleChange = (name, value) => {
        if (name === 'squareMeters') {
            if (Number(value) < 0) {
                dispatch(setHomeData({ 'squareMeters': '' }));
            } else {
                dispatch(setHomeData({ 'squareMeters': value }));
            }
        } else dispatch(setHomeData({ [name]: value }));
        setError({ ...error, [name]: false });
        if (name === "province") dispatch(searchCities(value, firstStep.codcia));
    };

    const handleCloseModalIsOpen = () => {
        setModalIsOpen(false);
    };

    const handleBack = async () => {
        try {
            setIsLoading(true)
            await dispatch(searchCities(titularData.province, firstStep.codcia));
            setIsLoading(false)
            dispatch(setFirstFormCompleted(true));
            navigate('/datosTitular')
        } catch (error) {
            let message = `Error searchCities | ${error}`;
            dispatch(createErrorEmail(message));
            dispatch(setErrorEncrypt(true))
            navigate('/error');
        };
    };

    const onNextPage = () => {
        setGoToNextPage(false);
        dispatch(setCurrentTab(3));
        dispatch(setGlobalTab(0));
        navigate('/pago');
    };

    const handleSubmit = async () => {
        if (!homeData.homeType) {
            setError({ ...error, homeType: true });
            return;
        };
        if (!homeData.address || homeData.address.length < 5 /*|| !/^[a-zA-Z0-9\s]+$/.test(homeData.address)*/) {
            setError({ ...error, address: true });
            return;
        }
        if (statePlanDetail.length > 0) {
            const foundHomeData = statePlanDetail.filter((e) => e.trim().toLowerCase() === homeData.address.toLowerCase());
            if (foundHomeData.length > 0) {
                setError(prevState => ({
                    ...prevState,
                    address: true,
                    registeredAddress: true
                }));
                return;
            };
        }
        if (!homeData.province) {
            setError({ ...error, province: true });
            return;
        }
        if (!homeData.city) {
            setError({ ...error, city: true });
            return;
        }
        if (!homeData.squareMeters || homeData.squareMeters.length < 1 || Number(homeData.squareMeters) < 5) {
            setError({ ...error, squareMeters: true });
            return;
        }
        else {
            setIsLoading(true);
            await dispatch(saveHomeData(homeData, codpmpol));
            setTimeout(() => { setIsLoading(false); }, 500);
            setGoToNextPage(true);
        }
    };

    useEffect(() => {
        if (!codpmpol) {
            try {
                const getLocalStorageCodpmpol = () => { return JSON.parse(localStorage.getItem('codpmpol')) || [] };
                const storageCodpmpol = getLocalStorageCodpmpol();
                if (Array.isArray(storageCodpmpol)) {
                    let message = `Error Recid | HomeData | Intencion: ${firstStep.nro} | DNI TITULAR: ${titularData.dni} | NOMBRE TITULAR: ${titularData.name + ' ' + titularData.lastname}`
                    dispatch(createErrorEmail(message));
                    dispatch(setErrorEncrypt(true))
                    navigate('/error');
                } else {
                    dispatch(setCodpmpol(storageCodpmpol));
                    if (!localStorage.getItem('homeData')) {
                        localStorage.setItem("homeData", JSON.stringify(homeData));
                    } else {
                        const dataFirstStep = JSON.parse(localStorage.getItem("firstStep"));
                        dispatch(setFirstStep({ ...firstStep, ...dataFirstStep }));
                        const dataTitular = JSON.parse(localStorage.getItem("titularData"));
                        dispatch(setTitularData({ ...titularData, ...dataTitular }));
                        const dataHogar = JSON.parse(localStorage.getItem("homeData"));
                        dispatch(setHomeData({ ...homeData, ...dataHogar, city: '', province: '' }));
                        dispatch(setAdditionalData('Datos Hogar'));
                    };
                };
            } catch (error) {
                let message = `Error en Datos de Hogar | ${error}`
                dispatch(createErrorEmail(message));
                dispatch(setErrorEncrypt(true))
                navigate('/error');
            }
        }
    }, []);

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            event.preventDefault();
            event.returnValue = 'Estoy a punto de refrescarme';
        };
        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);


    useEffect(() => {
        localStorage.setItem("homeData", JSON.stringify(homeData));
    }, [homeData]);


    useEffect(() => {
        if (/*homeData.city !== "" && */homeData.province) {
            const foundProvince = provinces?.find((e) => e.value === homeData.province)
            setValueProvince(foundProvince)
            handleChange('province', homeData.province);
        };
    }, []);

    useEffect(() => {
        if (homeData.city /*&& homeData.province !== ""*/) {
            const foundCity = cities?.find((e) => e.value === homeData.city)
            setValueCity(foundCity)
            handleChange('city', homeData.city);
        };
    }, []);

    useEffect(() => {
        setError({ ...error, province: false })
    }, [homeData.province, valueProvince])

    useEffect(() => {
        setError(prevState => ({
            ...prevState,
            registeredAddress: false,
            address: false
        }));
    }, [homeData.address]);

    useEffect(() => {
        dispatch(setAllSteps(3));
    }, [])

    useEffect(() => {
        dispatch(setAdditionalData('Datos Hogar'));
    }, []);

    useEffect(() => {
        dispatch(setCurrentTab(2));
    }, []);

    useEffect(() => {
        if (homeData.registeredAddress !== '' && goToNextPage) {
            setModalIsOpen(true);
            setGoToNextPage(false);
        } else if (goToNextPage) onNextPage();
    }, [homeData.registeredAddress, goToNextPage]);

    useEffect(() => {
        const dataCities = cities?.map(item => ({
            value: item.value,
            label: corregirCaracteresRotos(item.label),
        }));
        setListCities(dataCities);
    }, [cities]);

    return (
        <div className='testdiv' >
            {
                isLoading ?
                    <Spinner />
                    :
                    <>
                        <Layout>
                            <Container style={{ paddingLeft: 6, paddingRight: 6, maxWidth: 280 }}>
                                <div style={{ marginTop: '20px' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'center' }}>
                                        {/* <p style={{ marginTop: '3px', marginBottom: '5px' }}>
                                        Ingresa los datos de la vivienda
                                    </p> */}
                                    </div>
                                    <FormControl sx={{ m: 1, width: "30ch" }} error={error.homeType}>
                                        <InputLabel>Tipo de vivienda</InputLabel>
                                        <Select
                                            value={homeData.homeType}
                                            label="Tipo de vivienda"
                                            name='homeType'
                                            onChange={({ target }) => handleChange('homeType', target.value)}
                                        >
                                            {/* <MenuItem value={''}>Tipo de vivienda</MenuItem> */}
                                            <MenuItem value={'0'}>Casas y Deptos en Planta Baja</MenuItem>
                                            <MenuItem value={'1'}>Deptos 1 Piso en adelante/<br />Casas en Countries/<br />Barrios Cerrados</MenuItem>
                                        </Select>
                                        {error.homeType && <FormHelperText>Tipo de vivienda requerido</FormHelperText>}
                                    </FormControl>

                                    <Box sx={{ '& > :not(style)': { m: 1, width: '30ch' } }} noValidate autoComplete="off">
                                        <TextField
                                            error={error.address || error.registeredAddress}
                                            value={homeData.address}
                                            label="Domicilio a asegurar"
                                            name='address'
                                            // onKeyDown={handleKeyDown2}
                                            onChange={({ target }) => {
                                                let updatedValue = target.value;
                                                updatedValue = updatedValue.slice(0, 50); // Limitar a 50 caracteres
                                                updatedValue = updatedValue.replace(/[^\w\sñÑáéíóúÁÉÍÓÚ]/g, '')
                                                // updatedValue = updatedValue.replace(/[^a-zA-Z0-9ñÑ\s]/g, '');
                                                handleChange('address', updatedValue);
                                            }}
                                            helperText={error.address ? 'Domicilio a asegurar es requerido' : error.registeredAddress ? 'Domicilio no disponible. Ingrese otro' : ''} />
                                    </Box>
                                    {/* <FormControl sx={{ m: 1, width: "30ch" }} error={error.province}>
                                        <InputLabel>Provincia</InputLabel>
                                        <Select
                                            name='province'
                                            value={homeData.province}
                                            label="Provincia"
                                            onChange={({ target }) => handleChange('province', target.value)}
                                        >
                                            <MenuItem value={''}>Provincia</MenuItem>
                                            {provinces?.map((e) => (
                                                <MenuItem value={e.value}>{e.label}</MenuItem>
                                            ))}

                                        </Select>
                                        {error.province && <FormHelperText>Provincia es requerido</FormHelperText>}
                                    </FormControl> */}
                                    {/* ------------------------------------------------------------------------------------------            */}
                                    <FormControl error={error.province}>
                                        <CustomSelect
                                            // value={titularData.province === '' ? '' : titularData.province}
                                            value={valueProvince}
                                            options={[...provinces]}
                                            label="Provincia"
                                            name='province'
                                            // onChange={(_, { value, label }) => handleChange('province', value)}
                                            onChange={(_, newValue) => {
                                                if (newValue) {
                                                    setValueProvince(newValue)
                                                    handleChange('province', newValue.value)
                                                } else {
                                                    setValueProvince(null)
                                                    handleChange('province', '')
                                                }
                                                setValueCity(null)
                                                handleChange('city', '')
                                            }}
                                            // disabled={titularData.nationality === ""}
                                            error={error.province}
                                            helperText={'Provincia es requerido'}
                                        />
                                    </FormControl>
                                    {/* ------------------------------------------------------------------------------------------            */}

                                    <FormControl error={error.city} >
                                        <CustomSelect
                                            value={valueCity}
                                            options={[...listCities]}
                                            label="Localidad"
                                            name='city'
                                            onChange={(_, newValue) => {
                                                if (newValue) {
                                                    setError({ ...error, 'city': false })
                                                    setValueCity(newValue)
                                                    handleChange('city', newValue.value)
                                                } else {
                                                    setValueCity(null)
                                                    handleChange('city', '')
                                                }
                                            }}
                                            error={error.city}
                                            disabled={homeData.province === ""}
                                            helperText={'Localidad es requerido'}
                                        />
                                    </FormControl>
                                    {/* ------------------------------------------------------------------------------- */}
                                    {/* <FormControl sx={{ m: 1, width: "30ch" }} error={error.city}>
                                        <InputLabel>Localidad</InputLabel>
                                        <Select
                                            name='city'
                                            value={homeData.city}
                                            label="Tipo de vivienda"
                                            onChange={({ target }) => handleChange('city', target.value)}
                                            disabled={homeData.province === ""}
                                        >
                                            <MenuItem value={''}>Localidad</MenuItem>
                                            {cities?.map((e) => (
                                                <MenuItem value={e.value}>{e.label}</MenuItem>
                                            ))}
                                        </Select>
                                        {error.city && <FormHelperText>Localidad es requerido</FormHelperText>}
                                    </FormControl> 
                                    -----------------------------------------------------------------------------------*/}
                                    <Box sx={{ '& > :not(style)': { m: 1, width: '30ch' } }} noValidate autoComplete="off">
                                        <TextField
                                            error={error.squareMeters}
                                            name='squareMeters'
                                            value={homeData.squareMeters}
                                            label="Metros Cuadrados"
                                            type='number'
                                            onChange={({ target }) => handleChange('squareMeters', target.value)}
                                            onKeyDown={handleKeyDown}
                                            helperText={error.squareMeters ? 'Metros Cuadrados es requerido' : ""} />
                                    </Box>
                                </div>
                                <div className='contenedorBotones'>
                                    <Stack spacing={1} direction="row">
                                        <Button style={{ borderRadius: 20, textTransform: 'capitalize' }} size="medium" color={CODEMP_MUSIMUNDO.includes(codemp) ? "secondary" : "blue"} variant="outlined" onClick={handleBack}>Atrás</Button>
                                        <Button style={{ borderRadius: 20, textTransform: 'capitalize' }} size="medium" color={CODEMP_MUSIMUNDO.includes(codemp) ? "secondary" : "blue"} variant="contained" onClick={handleSubmit}>Continuar</Button>
                                    </Stack>
                                </div>
                            </Container>
                        </Layout>
                        <Modal
                            open={modalIsOpen}
                            onClose={handleCloseModalIsOpen}
                            closeAfterTransition
                        >
                            <Fade in={modalIsOpen}>
                                <Box sx={customStyles}>
                                    <Typography id="transition-modal-title" variant="h6" component="h4" style={{ fontFamily: 'Roboto' }}>
                                        Aviso de contratación
                                    </Typography>
                                    <Typography variant="body2" sx={{ mt: 1 }} style={{ fontFamily: 'Roboto' }}>
                                        {`${homeData.registeredAddress}, por favor ingrese uno nuevo. `}
                                    </Typography>
                                    <div
                                        className="contenedorBotones"
                                        style={{
                                            spacing: 9,
                                            display: "flex",
                                            flexDirection: "row",
                                            margin: 13,
                                            position: "relative",
                                        }}
                                    >
                                        <Button
                                            style={{ borderRadius: 20, textTransform: "capitalize" }}
                                            size="medium"
                                            color={CODEMP_MUSIMUNDO.includes(codemp) ? "secondary" : "blue"}
                                            variant="contained"
                                            type="submit"
                                            onClick={handleCloseModalIsOpen}
                                        >
                                            Aceptar
                                        </Button>
                                    </div>
                                </Box>
                            </Fade>
                        </Modal>
                    </>
            }
        </div>
    )
}

export default HomeData;